module.exports = __webpack_public_path__ + "static/media/tpo.2212df37.jpeg";